<template>
  <el-config-provider :locale="currentLocale">
    <div class="app-container">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </el-config-provider>
</template>

<script setup lang="ts" name="App">
import { ElConfigProvider } from 'element-plus'
import en from 'element-plus/es/locale/lang/en'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { computed, onUnmounted, watch } from 'vue'

import { i18n } from '@/langs'
import { useConfigStore } from '@/stores/configStore'

import { LanguageEnum } from './constants'

const currentLocale = computed(() => {
  const localeName = i18n.global.locale.value
  if (localeName === LanguageEnum.ZH_CN) return zhCn
  else if (localeName === LanguageEnum.EN) return en
  else return en
})

const configStore = useConfigStore()
let globalCssStyleEl: HTMLStyleElement | null = null

const applyGlobalSettingsCss = (css: string | null | undefined) => {
  if (globalCssStyleEl) {
    globalCssStyleEl.remove()
    globalCssStyleEl = null
  }
  const raw = css?.trim()
  if (!raw) return
  globalCssStyleEl = document.createElement('style')
  globalCssStyleEl.id = 'gt-global-settings-css'
  globalCssStyleEl.textContent = raw
  document.head.appendChild(globalCssStyleEl)
}

watch(
  () => configStore.getterCurrentConfig?.globalSettingsCss,
  v => applyGlobalSettingsCss(v),
  { immediate: true }
)

onUnmounted(() => {
  if (globalCssStyleEl) {
    globalCssStyleEl.remove()
    globalCssStyleEl = null
  }
})
</script>

<style lang="scss"></style>
